export default __webpack_public_path__ + "static/media/search.13d75cc2.png";